import { DataInitialize } from '../DataInitialize';
import { DataCallback } from '../DataCallback';

export abstract class FirestoreRepository implements DataInitialize {

  abstract readonly collection: any;

  public async getAll(callback: DataCallback): Promise<boolean> {
    await this.collection.getAll(callback);
    return true;
  }

  public waitSnapshot(callback: DataCallback, lastUpdate: any): void {
    this.collection.waitSnapshot(callback, lastUpdate);
  }

  public save(data: any) {
    this.collection.save(data);
  }
}

export class DummyRepository extends FirestoreRepository {
  public get collection():any {
    return '';
  }
}